export const convertDate = (dateToConvert) => {
  if (!dateToConvert) return '';
  const date = new Date(dateToConvert);
  const year = date.getFullYear();
  const month = (`0${date.getMonth() + 1}`).slice(-2);
  const day = (`0${date.getDate()}`).slice(-2);
  return `${year}-${month}-${day}`;
};

export const calculateBusinessDays = (startDate, endDate) => {
  let start = new Date(startDate);
  let end = new Date(endDate);
  let count = 0;

  while (start <= end) {
    const day = start.getDay();
    if (day !== 0 && day !== 6) { // Exclude Sundays (0), Saturdays (6)
      count += 1;
    }
    start.setDate(start.getDate() + 1);
  }
  return count;
};

export const addBusinessDays = (startDate, businessDays) => {
  let date = new Date(startDate);
  let addedDays = 0;

  while (addedDays < businessDays) {
    date.setDate(date.getDate() + 1);
    const day = date.getDay();
    if (day !== 0 && day !== 6) { // Exclude Sundays (0), Saturdays (6)
      addedDays += 1;
    }
  }
  return convertDate(date);
};
